import { render, staticRenderFns } from "./ManageArticles.vue?vue&type=template&id=413b98e5&scoped=true"
import script from "./ManageArticles.vue?vue&type=script&lang=js"
export * from "./ManageArticles.vue?vue&type=script&lang=js"
import style0 from "./ManageArticles.vue?vue&type=style&index=0&id=413b98e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413b98e5",
  null
  
)

export default component.exports